<template>
  <l-map
    :base-layers="baseLayers"
    :center="activeView"
    :control-layers="true"
    :layer-groups="layerGroups"
    :marker="marker"
    @marker-drawn="setScToolPoint"
    @go-home="goHome()"
  >
    <l-layer-thredds-wms
      v-if="isSuitabilityLayerVisible"
      id="wmsSuitability"
      :layer="suitabilityLayer"
      :identify="true"
      :legend="true"
      :legend-options="layers.suitability.legendConfig"
    />
    <l-layer-geoserver-wms
      id="wmsBathymetry"
      :layer="layers.bathymetry"
      :identify="true"
      :legend="true"
      :legend-options="layers.bathymetry.legendConfig"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
    <l-layer-geoserver-wms
      id="wmsSeabedSubstrate"
      :layer="layers.seabed"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
    <l-layer-geoserver-wms
      id="wmsSeaFloorGeomorphology"
      :layer="layers.geomorphology"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />

    <l-layer-geoserver-wms
      id="wmsSeabedBroadHabitats"
      :layer="layers.broadHabitats"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
    <l-layer-geoserver-wms
      id="wmsSeabedMediumHabitats"
      :layer="layers.mediumHabitats"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
    <l-layer-geoserver-wms
      id="wmsVessels"
      :layer="layers.vessels"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
    <l-layer-geoserver-wms
      id="wmsOceanEnergy"
      :layer="layers.energy"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
    <l-layer-geoserver-wms
      id="wmsFinfish"
      :layer="layers.finfish"
      :identify="false"
      :legend="true"
      :show-in-layer-switcher="true"
      :load-on-init="false"
    />
  </l-map>
</template>
<script>
import LMap from "@/components/map/LMap";
import LMapLayerThreddsWMS from "@/components/map/LMapLayerThreddsWMS";
import LMapLayerGeoServerWMS from "@/components/map/LMapLayerGeoserverWMS";
import {
  LAYER_GROUPS,
  SUITABILITY,
  FINFISH_FARMS,
  WMS_LEGEND,
  VESSELS_TRAFFIC,
  OCEANS_ENERGY,
  BATHYMETRY,
  SEABED_SUBSTRATE,
  SEABED_GEOMORPHOLOGY,
  SEABED_BROAD_HABITATS,
  SEABED_MEDIUM_HABITATS
} from "@/config/layers-config.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { MENUS_INDEX } from "@/constants.js";

export default {
  components: {
    LMap,
    "l-layer-thredds-wms": LMapLayerThreddsWMS,
    "l-layer-geoserver-wms": LMapLayerGeoServerWMS
  },
  data: () => {
    return {
      baseLayers: [
        { name: "osm-mapnik", alias: "OSM - MAPNIK" },
        { name: "esri-gray", alias: "Gray - ESRI" },
        { name: "esri-oceans", alias: "Oceans - ESRI" },
        { name: "carto-dark", alias: "Dark - Carto" }
      ],
      layerGroups: LAYER_GROUPS,
      wmsLegendOptions: WMS_LEGEND,
      layers: {
        suitability: SUITABILITY,
        finfish: FINFISH_FARMS,
        vessels: VESSELS_TRAFFIC,
        energy: OCEANS_ENERGY,
        bathymetry: BATHYMETRY,
        seabed: SEABED_SUBSTRATE,
        geomorphology: SEABED_GEOMORPHOLOGY,
        broadHabitats: SEABED_BROAD_HABITATS,
        mediumHabitats: SEABED_MEDIUM_HABITATS
      }
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker,
      suitabilityLayer: state => {
        return {
          active: state.wmsLayerSuitability.activeLayer,
          url: state.wmsLayerSuitability.url,
          urlFuture: state.wmsLayerSuitability.urlFuture,
          alias: state.wmsLayerSuitability.name,
          wmsOptions: state.wmsLayerSuitability.options,
          identify: state.wmsLayerSuitability.identify,
          visible: state.wmsLayerSuitability.visible,
          hasFuture: state.wmsLayerSuitability.hasFuture
        };
      }
    }),
    ...mapGetters("map", {
      activeView: "activeMapView",
      isSuitabilityLayerVisible: "isSuitabilityLayerVisible"
    })
  },
  methods: {
    ...mapActions({
      setActiveMenus: "setActiveMenus",
    }),
    ...mapActions("map", {
      setScToolPoint: "setScToolPoint",
    }),
    goHome() {
      this.setActiveMenus({
        top: MENUS_INDEX.SCALES.GLOBAL,
        mid: MENUS_INDEX.SECTORS.GLOBAL_AQUACULTURE,
        bottom: -1
      });
    }
  }
};
</script>
<style scoped>
/* Override leaflet styles */
.leaflet-control-colorBar-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 0.8rem;
}
</style>
